import Vue from "vue";
import VueRouter from "vue-router";
// import cookies from "@/plugins/cookie";
import { clearPending } from "@/utils/request";
import Login from "@/views/login/index.vue";

import Admin from "@/views/admin/index.vue";
const NotFound = () => import("@/views/errorPage/404.vue");
// 导师管理
const MentorManage = () => import("@/views/admin/mentor_manage/index.vue");
const TeacherList = () =>
  import("@/views/admin/mentor_manage/teacher/list.vue");
const TeacherInfo = () =>
  import("@/views/admin/mentor_manage/teacher/info.vue");
const CounselList = () =>
  import("@/views/admin/mentor_manage/counsel/list.vue");
const CompanyList = () =>
  import("@/views/admin/mentor_manage/company/list.vue");
const CompanyInfo = () =>
  import("@/views/admin/mentor_manage/company/info.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Login
  },
  {
    path: "/admin",
    component: Admin,
    // beforeEnter: (to, from, next) => {
    //   const hasToken = cookies.get("backToken");
    //   if (hasToken) {
    //     next();
    //   } else {
    //     next({ path: "/" });
    //   }
    // },
    children: [
      {
        path: "",
        redirect: "mentorManage"
      },
      {
        path: "mentorManage",
        component: MentorManage,
        children: [
          {
            path: "",
            redirect: "teacherList"
          },
          {
            path: "teacherList",
            component: TeacherList
          },
          {
            path: "teacherInfo/:method",
            component: TeacherInfo
          },
          {
            path: "counselList",
            component: CounselList
          },
          {
            path: "companyList",
            component: CompanyList
          },
          {
            path: "companyInfo/:method",
            component: CompanyInfo
          }
        ]
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: "/404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  clearPending();
  next();
});

export default router;
